import { CUSTOMER_APIS } from "@/api_framework/api_config";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useSendOTPAPI = () => {
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (email: string, includeVeticMetaData = false) => {
      dispatch(
        setLoading({
          key: "isSendOTPInProgress",
          status: true,
        }),
      );
      try {
        const hostname = typeof window !== "undefined" ? window.location.hostname.toLowerCase() : "";
        const isHDAddressFlow = hostname === "address.vetic.in" || hostname.endsWith(".address.vetic.in");

        const headers: Record<string, string> = {
          "Content-Type": "application/json",
        };
        if (includeVeticMetaData || isHDAddressFlow) {
          headers["Vetic-Meta-Data"] = JSON.stringify({});
        }

        const response: boolean = await axios
          .post(
            CUSTOMER_APIS?.SEND_OTP?.baseURL ?? "",
            {
              email: email,
            },
            {
              headers,
            },
          )
          .then((res: AxiosResponse<{ status: boolean; message: string; data: any }>) => {
            dispatch(
              setLoading({
                key: "isSendOTPInProgress",
                status: false,
              }),
            );
            if (res.data.status) {
              return true;
            } else {
              return false;
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            dispatch(
              setLoading({
                key: "isSendOTPInProgress",
                status: false,
              }),
            );
            captureError(e);
            return false;
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
        return false;
      }
    },
    [dispatch],
  );
  return { execute };
};
